import React from "react";

import { donutGradient } from "../utils/portfolio";
import "./Donut.css";

/**
 * A pie built from holdings ({ label, pct, ticker }).
 * `children` goes in the hole (e.g. a count or a return).
 */
const Donut = ({ holdings, size = 132, ring = 20, label, children }) => {
  return (
    <div
      className="donut"
      role="img"
      aria-label={label}
      style={{ width: size, height: size, background: donutGradient(holdings) }}
    >
      {ring > 0 && (
        <div className="donut__hole" style={{ inset: ring }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Donut;
